/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_New_Err_Source_DupInputs */

const vi_sl_new_err_source_dup = /** @type {(inputs: Sl_New_Err_Source_DupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô nguồn đã được chọn ở dòng khác`)
};

/**

* @param {Sl_New_Err_Source_DupInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_new_err_source_dup = /** @type {((inputs?: Sl_New_Err_Source_DupInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_New_Err_Source_DupInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_new_err_source_dup(inputs)
});